import { render, staticRenderFns } from "./satislar.vue?vue&type=template&id=7fde39e6&scoped=true&"
import script from "./satislar.vue?vue&type=script&lang=js&"
export * from "./satislar.vue?vue&type=script&lang=js&"
import style0 from "./satislar.vue?vue&type=style&index=0&id=7fde39e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fde39e6",
  null
  
)

export default component.exports